import { Checkbox, Form } from "antd";
import { useState } from "react";
// @styles 
import './styles.scss'

export default function BigCheckboxField({ info, key }) {
    const [isError, setIsError] = useState(false);
    const validate = info.validate ? info.validate : {};

    const validateChecked = (_, value) => {
        setIsError(!value);
        return value ? Promise.resolve() : Promise.reject(new Error(''))
    };

    return (
        <div className='big-check'>
            <Form.Item
                name={info.key}
                key={key}
                valuePropName={validate.required ? "checked" : null}
                rules={[
                    {
                        validator: validateChecked,
                        message: ''
                    }
                ]}
            >
                <Checkbox
                    className={`c-dr ${isError && 'big-check-error'}`}
                    data-testid='check-vali'
                >
                    {info.label}
                </Checkbox>
            </Form.Item>
        </div>
    )
}